<template>
  <div v-if="infosPage.id_template === undefined">
    <h3 class="mb-15 mt-15 w-full text-center">
      Veuillez définir un modèle de page pour ce type d'évaluation.
    </h3>
  </div>
  <div
    v-else
    @keydown="progressbar.userKeyDown()"
    @keyup="progressbar.userKeyUp()"
    @click="calculate_progress"
  >
    <!-- Popup modal create evaluation -->
    <create-evaluation-popup
      :is-opened="show_add_evaluation"
      :date-debut="form.date_debut_evaluation"
      :date-fin="form.date_fin_evaluation"
      @close="show_add_evaluation = false"
      @changeDateDebut="
        (newValue) => {
          if (
            form.date_fin_evaluation == '' ||
            $verifyDates({ debut: newValue, fin: form.date_fin_evaluation })
          ) {
            form.date_debut_evaluation = newValue;
          } else {
            badDates();
            form.date_debut_evaluation = '';
          }
        }
      "
      @changeDateFin="
        (newValue) => {
          if (
            form.date_debut_evaluation == '' ||
            $verifyDates({ debut: form.date_debut_evaluation, fin: newValue })
          ) {
            form.date_fin_evaluation = newValue;
          } else {
            badDates();
            form.date_fin_evaluation = '';
          }
        }
      "
      @createEvaluation="create_evaluation"
    />
    <!-- END Popup modal create evaluation -->

    <!-- BEGIN Popup to confirm to close an evaluation -->
    <close-evaluation-popup
      :is-opened="confirmCloseEvaluation > -1"
      :is-step-one="confirmCloseEvaluation == 0"
      :is-step-two="confirmCloseEvaluation == 1"
      :today="today"
      @close="confirmCloseEvaluation = -1"
      @closeEval="close_eval"
    />
    <!-- END Popup to confirm to close an evaluation -->

    <h3 class="my-15 w-full">
      {{ infosPage.libelle_template }}
    </h3>

    <!-- BEGIN Button add evaluation -->
    <div
      v-if="
        form.date_debut_evaluation == '' ||
        form.date_fin_evaluation == '' ||
        form.id_ref == 0 ||
        form.template == {}
      "
    >
      <div
        v-if="role === constants.ROLE_BENEFICIAIRE"
        class="flex justify-center mb-10"
      >
        <change-structure-input class="w-max" />
      </div>
      <div
        v-if="
          $can(infosPage.name_page + '_edit', infosPass.id_pass) &&
          (role !== constants.ROLE_BENEFICIAIRE || $freeParticulier())
        "
      >
        <div class="flex justify-center w-full">
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-indigo-600"
            bg-color-square="bg-indigo-600"
            icon-color="text-white"
            libelle="AJOUTER UNE ÉVALUATION"
            :uppercase="true"
            icon="plus-circle"
            type-shadow="shadow-indigo"
            @clickAction="show_add_evaluation = true"
          />
        </div>
        <div class="flex justify-center w-full">
          <illustration name="evaluation" class="mt-15" />
        </div>
      </div>
      <div v-else>
        <div class="text-indigo-600 text-lg text-center">
          Il n’y a pas d’évaluation en cours
          <span v-if="listEvaluationsNeopass.length > 0">
            , vous pouvez consulter
            <br />
            vos évaluations précédentes dans l’historique ci-dessous
          </span>
          .
        </div>
        <div class="flex justify-center w-full">
          <illustration name="notAllowed" class="mt-15" />
        </div>
      </div>
    </div>
    <!-- END Button add evaluation -->

    <!-- BEGIN Evaluation content -->
    <div class="m-5 md:m-15 2xl:m-20" v-else>
      <!-- data comes from CompetenceChart mixin -->
      <PopupCompareCarto
        :compare-carto="compareCarto"
        @close="closeCompare"
        @changeCompare="
          (index) => {
            changeCompare(index);
          }
        "
        :carto-to-compare="cartoToCompare"
        :history-to-display="historyToDisplay"
        :competences-cles="{}"
        :history-competences-cles="[]"
        :competences-informatique="competencesInformatique"
        :history-competences-informatique="
          historyCompetencesInformatique.filter(
            (hist) =>
              hist.template_name == competencesInformatique.template_name
          )
        "
        :competences-linguistique="{}"
        :history-competences-linguistique="[]"
        :competences-socio-pro="{}"
        :history-competences-socio-pro="{}"
        v-if="compareCarto"
      />

      <div
        v-if="role === constants.ROLE_BENEFICIAIRE"
        class="flex justify-center mb-10"
      >
        <change-structure-input class="w-max" />
      </div>

      <!-- Bloc action buttons -->
      <div
        v-if="
          (role !== constants.ROLE_BENEFICIAIRE &&
            $can(infosPage.name_page + '_edit', infosPass.id_pass)) ||
          $freeParticulier()
        "
        class="w-full mb-15 2xl:mb-20 flex justify-center"
      >
        <list-action-buttons
          :today="today"
          :libelle-template="infosPage.libelle_template"
          :can-compare-cartography="
            canCompare && listEvaluationsNeopass.length > 0
          "
          :can-compare-but-not-enough-evaluation="
            canCompare && listEvaluationsNeopass.length === 0
          "
          @confirmCloseEvaluation="confirmCloseEvaluation = 0"
          @displayCompareCarto="
            displayCompareCarto(constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE)
          "
        />
      </div>
      <!-- Bloc action buttons -->

      <!-- Remplir avec le modèle de page correspondant -->
      <!-- BEGIN Modèle de page Compétences informatiques par défaut -->
      <div v-if="['multi3', 'ref_multi3'].includes(form.type_temp)">
        <div v-for="(domaine, index) in form.template" :key="index">
          <div class="grid grid-cols-12 mb-15">
            <div
              class="col-span-full text-indigo-600 uppercase text-base font-normal"
            >
              {{ domaine[0].libelle }}
            </div>
            <div class="col-span-full grid grid-cols-12 gap-4">
              <div
                v-for="(field, jndex) in domaine"
                :key="jndex"
                class="col-span-full"
                :class="
                  jndex == 0
                    ? 'display-none'
                    : domaine.length > 2
                    ? 'md:col-span-4'
                    : 'md:col-span-6'
                "
              >
                <!-- use $set function to be reactive with form watch property -->
                <input-text
                  v-if="jndex !== 0 && field.type == 'text'"
                  :libelle="field.libelle"
                  :value="form.items[index].criterions[jndex]"
                  @input="
                    (newValue) => {
                      $set(form.items[index].criterions, jndex, newValue);
                    }
                  "
                  :necessary="true"
                />
                <input-select
                  v-if="jndex !== 0 && field.type == 'multi'"
                  :name="
                    field.libelle
                      .toLowerCase()
                      .replace(' ', '_')
                      .replace('\'', '') +
                    index +
                    jndex
                  "
                  :libelle="field.libelle"
                  :datas="field.criterions"
                  :necessary="true"
                  :value="form.items[index].criterions[jndex]"
                  @input="
                    (newValue) => {
                      $set(form.items[index].criterions, jndex, newValue);
                    }
                  "
                />
                <input-text-area
                  v-if="field.type == 'text-area'"
                  size="5"
                  :name="
                    field.libelle
                      .toLowerCase()
                      .replace(' ', '_')
                      .replace('\'', '')
                  "
                  :libelle="field.libelle"
                  :necessary="field.libelle.toLowerCase() !== 'commentaire'"
                  :value="form.items[index].criterions[jndex]"
                  @input="
                    (newValue) => {
                      $set(form.items[index].criterions, jndex, newValue);
                    }
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Modèle de page Compétences informatiques par défaut -->

      <!-- BEGIN Modèle de page CléA numérique -->
      <div
        v-if="['clea_num', 'ref_clea_num'].includes(form.type_temp)"
        class="flex flex-col"
      >
        <!-- BEGIN List domaines -->
        <drop-down-list
          prefix-libelle="Domaine "
          :current-field="currentField"
          :options="form.items"
          libelle-key-in-options-array="libelle"
          @chooseItem="
            (num) => {
              currentField = num;
            }
          "
        />
        <!-- END List domaines -->

        <!-- BEGIN criterions list -->
        <checkboxes-grid
          v-for="(skill, index) in form.items[currentField].skills"
          :key="index"
          class="my-4 md:my-8 md:mx-10"
          :title="currentField + 1 + '-' + (index + 1) + '. ' + skill.libelle"
          :list="
            skill.criterions.reduce(
              (acc, crit) => ({ ...acc, [crit.value]: crit.check }),
              {}
            )
          "
          @changeValue="
            (infos) => {
              // Determine the key by the libelle (because it is the only value return by the component in this event)
              var jndex = skill.criterions.reduce(
                (acc, crit, num) => ({ ...acc, [crit.value]: num }),
                {}
              )[infos.key];
              skill.criterions[jndex].check = infos.value;
            }
          "
        />
        <!-- END criterions list -->
      </div>
      <!-- END Modèle de page CléA numérique -->
    </div>
    <!-- END Evaluation content -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import axios from './../../../api';
import ClickOutside from 'vue-click-outside';
import VerifyDates from '../../../mixins/VerifyDates';

import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import CheckboxIndigo from '../../../components/Inputs/CheckboxIndigo';

import ActionButton from '../../../components/ActionButton';
import Icon from '../../../components/Icon';
import Illustration from '../../../components/Illustration';
import Popup from '../../../components/Popup';
import InfoBulle from '../../../components/InfoBulle';
import DropDownList from '../../../components/DropDownList.vue';
import CheckboxesGrid from '../../../components/CheckboxesGrid.vue';
import ChangeStructureInput from '../../../components/ChangeStructureInput.vue';

import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import CreateEvaluationPopup from '../../../components/Evaluations/CreateEvaluationPopup.vue';
import ListActionButtons from '../../../components/Evaluations/ListActionButtons.vue';
import CloseEvaluationPopup from '../../../components/Evaluations/CloseEvaluationPopup.vue';

import Constants from './../../../constants/';

export default {
  components: {
    PopupCompareCarto,
    ActionButton,
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    Illustration,
    Popup,
    InfoBulle,
    CheckboxIndigo,
    CreateEvaluationPopup,
    ListActionButtons,
    CloseEvaluationPopup,
    DropDownList,
    CheckboxesGrid,
    ChangeStructureInput,
  },

  props: ['progressbar'],
  name: 'Compétencesinformatique',

  mixins: [VerifyDates],

  data() {
    return {
      // Initial state of the form
      form: {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      },

      show_add_evaluation: false,
      selectedDate: null,
      confirmCloseEvaluation: -1, //-1 : modal closed / 0 : confirm close / 1 : evaluation closed
      showList: false,
      currentField: 0,

      cartoToCompare: '',
      compareCarto: false,
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      historyToDisplay: -1,

      constants: Constants,
    };
  },

  async created() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)

    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),

    ...mapActions({
      close_evaluation: 'neopass/close_evaluation',
      load_infos_pass: 'cartographiesIndividuelles/load_infos_pass',
      load_evaluations: 'cartographiesIndividuelles/load_evaluations',
    }),

    initForm() {
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },

    displayFieldList() {
      this.showList = !this.showList;
    },

    create_evaluation() {
      this.form.id_ref = this.infosPage.id_template;

      axios
        .get('/api/page_templates/' + this.form.id_ref)
        .then((response) => {
          /* Load template for the form */
          let datas = response.data.data;

          let last_version = datas[datas.length - 1];
          this.form.version_template = datas.length;

          this.form.type_temp = response.data.type;
          this.form.name_temp = response.data.name;

          if (last_version.length > 0) {
            this.form.template = last_version;
            if (
              ['multi1', 'ref_multi1', 'multi3', 'ref_multi3'].includes(
                this.form.type_temp
              )
            ) {
              this.form.template.forEach((field) => {
                //prepare list of criterions to add default values. it deserves to satisfy reactivity in vuejs and the form watched
                let crits = [];
                field.forEach((crit) => {
                  crits.push('');
                });

                this.form.items.push({
                  name: field[0].libelle,
                  criterions: crits,
                });
              });
            } else {
              //reférentiel CLEA numérique
              this.form.items = [...this.form.template];
            }
          } else {
            this.form.template = [];
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response.data);
        });

      this.show_add_evaluation = false;
    },

    close_eval() {
      // load new evaluation's cartography after it has been saved
      this.close_evaluation(this.form).then(() => {
        this.$store.dispatch('cartographiesIndividuelles/change_page', [
          this.$route.params.id,
          Constants.PAGE_CARTOGRAPHIE_COMPETENCES_PERSO,
        ]);
      });

      (this.form = {
        id_ref: 0,
        version_template: 0,
        type_temp: '',
        name_temp: '',
        template: [],
        date_debut_evaluation: '',
        date_fin_evaluation: '',
        items: [],
      }),
        (this.confirmCloseEvaluation = 1);
    },

    async displayCompareCarto(typeCarto) {
      await this.load_infos_pass(this.infosPass.id_pass);

      Promise.all([this.load_evaluations()])
        .then(() => {
          this.compareCarto = true;
          this.cartoToCompare = typeCarto;
        })
        .catch((error) => {
          console.error(`Error while loading page: ${error}`);
        });
    },

    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },
  },

  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      role: 'auth/role',
      listEvaluationsNeopass: 'neopass/listEvaluations',
    }),

    // Compare carto button should only show if user can see them and if there is at least 1 evaluation
    canCompare() {
      return this.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE);
    },

    today() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date().toLocaleDateString(undefined, options);
    },

    evalStartDate() {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      if (this.form.date_debut_evaluation !== '') {
        return new Date(this.form.date_debut_evaluation).toLocaleDateString(
          undefined,
          options
        );
      } else {
        return new Date().toLocaleDateString(undefined, options);
      }
    },

    competencesInformatique() {
      return (
        (this.neopassDatas || {})[
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
        ] || {}
      );
    },

    historyCompetencesInformatique() {
      return (
        (this.listEvaluations || {})[
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
        ] || []
      );
    },
  },

  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
